import { FC } from "react";
import { useForm } from "react-hook-form";

import { TextAreaFormField } from "src/components/Form/TextAreaFormField";
import { ConfirmActionModal } from "src/components/Modal";
import { useT } from "src/internationalization";

type CommentModalProps = {
  onClose: () => void;
  onConfirm: (comment: string) => void;
  loading: boolean;
};

type FormData = {
  comment: string;
};

export const CommentModal: FC<CommentModalProps> = ({ onClose, onConfirm, loading }) => {
  const t = useT();
  const { control, handleSubmit } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    onConfirm(data.comment);
  };

  return (
    <ConfirmActionModal
      loading={loading}
      title={t("header.switcher.settings.schema.modal.comment.title")}
      size="sm"
      onClose={onClose}
      onConfirm={handleSubmit(onSubmit)}
      confirmButtonText={t("general.actions.confirm")}
      initialFocus={"#comment-field"}
    >
      <TextAreaFormField
        id="comment-field"
        label=""
        control={control}
        name="comment"
        placeholder={t("header.switcher.settings.schema.modal.comment.placeholder")}
        rules={{ required: t("header.switcher.settings.schema.modal.comment.required") }}
      />
    </ConfirmActionModal>
  );
};
